import React from 'react'
import PropTypes from 'prop-types'
import Loading from 'components/Loading'
import { AccountAndLoanList } from './components/AccountAndLoan'
import constants from 'constants'
import { hasAccess } from 'utils/hasAccess'
import FeatureGuard from '../../components/FeatureToggle/FeatureGuard'

const styles = Object.assign(
  {},
  require('./AccountsAndLoans.scss'),
  require('components/Table/Table.scss'),
  { columns: require('./columns.scss') },
)

class AccountsAndLoansView extends React.Component {
  static propTypes = {
    accountsAndLoans: PropTypes.object.isRequired,
    accountType: PropTypes.string,
    currentUser: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    openBankTransferForm: PropTypes.func.isRequired,
    selectedAccount: PropTypes.func.isRequired,
  }
  static defaultProps = {
    accountType: '',
  }
  render() {
    const {
      accountsAndLoans, accountType, history, currentUser, openBankTransferForm, selectedAccount,
    } = this.props
    if (accountsAndLoans.isFetching) {
      return (<Loading pageLoading />)
    }

    return (
      <FeatureGuard featureName="Accounts & Loans" user={currentUser}>
        <div className={styles.content}>
          <section className={styles.section}>
            {accountsAndLoans.fetched && accountsAndLoans.accountsandloans && String(accountType) === constants.ACCOUNTSANDLOANS.ACCOUNT_TYPE.POST_SWIFT &&
            <AccountAndLoanList
              accountAndLoansItems={accountsAndLoans.accountsandloans.filter(acl => String(acl.productType) === constants.ACCOUNTSANDLOANS.PRODUCT_TYPE.SHORT_TERM_LOAN)}
              accountType={accountType}
              accountsAndLoans={accountsAndLoans}
              bankTransferEnable={(window.location.href.indexOf('admin/') > -1 ? hasAccess(currentUser, 'Accounts and Loans', history, 'RW', false) : hasAccess(currentUser, 'Accounts and Loans', history, 'R', false))}
              header={constants.ACCOUNTSANDLOANS.PRODUCT_TYPE.SHORT_TERM_LOAN_LABEL}
              openBankTransferForm={openBankTransferForm}
              selectedAccount={selectedAccount}
            />}
          </section>
          <section className={styles.section}>
            {accountsAndLoans.fetched && accountsAndLoans.accountsandloans && String(accountType) === constants.ACCOUNTSANDLOANS.ACCOUNT_TYPE.POST_SWIFT &&
            <AccountAndLoanList
              accountAndLoansItems={accountsAndLoans.accountsandloans.filter(acl => String(acl.productType) === constants.ACCOUNTSANDLOANS.PRODUCT_TYPE.PARTNER_PERSONAL_LOAN)}
              accountType={accountType}
              header={constants.ACCOUNTSANDLOANS.PRODUCT_TYPE.PARTNER_PERSONAL_LOAN_LABEL}
              selectedAccount={selectedAccount}
            />}
          </section>
          <section className={styles.section}>
            {accountsAndLoans.fetched && accountsAndLoans.accountsandloans && String(accountType) === constants.ACCOUNTSANDLOANS.ACCOUNT_TYPE.POST_SWIFT &&
            <AccountAndLoanList
              accountAndLoansItems={accountsAndLoans.accountsandloans.filter(acl => String(acl.productType) === constants.ACCOUNTSANDLOANS.PRODUCT_TYPE.PARTNER_CAPITAL_LOANS)}
              accountType={accountType}
              header={constants.ACCOUNTSANDLOANS.PRODUCT_TYPE.PARTNER_CAPITAL_LOANS_LABEL}
              selectedAccount={selectedAccount}
            />}
          </section>
          <section className={styles.section}>
            {accountsAndLoans.fetched && accountsAndLoans.accountsandloans && String(accountType) === constants.ACCOUNTSANDLOANS.ACCOUNT_TYPE.PRE_SWIFT &&
            <AccountAndLoanList
              accountAndLoansItems={accountsAndLoans.accountsandloans}
              accountType={accountType}
              header={constants.ACCOUNTSANDLOANS.PRODUCT_TYPE.SHORT_TERM_LOAN_LABEL}
              selectedAccount={selectedAccount}
            />}
          </section>
        </div>
      </FeatureGuard>
    )
  }
}

export default AccountsAndLoansView



// WEBPACK FOOTER //
// ./src/views/AccountsAndLoans/AccountsAndLoans.js